module.exports = __webpack_public_path__ + "img/fruit_banana.30dfc971.png";